/**
 *
 * @typedef Education
 * @returns {{
 *  get(): Promise,
 *  save(slug: string, inputs: object): Promise,
 *  put(slug: string, id: [string, number]): Promise
 *  delete(slug: string, id: [string, number]): Promise
 *  patch(slug: string, id: [string, number]): Promise
 * }}
 */
export const Educations = axios => ({
  /**
   * Save education form
   *
   * @param payload: object
   * @param slug: string
   * @returns Promise
   */
  save (slug, payload) {
    return axios.post(`/v1/profiles/${slug}/educations`, payload)
  },
  /**
   * Get education list
   *
   * @param slug: string
   * @returns Promise
   */
  list (slug) {
    return axios.get(`/v1/profiles/${slug}/educations`)
  },
  /**
   * Get education item
   *
   * @param slug: string
   * @param {string} educationSlug
   * @returns Promise
   */
  get (slug, educationSlug) {
    return axios.get(`/v1/profiles/${slug}/educations/${educationSlug}`)
  },
  /**
   * Update education list
   *
   * @param slug: string
   * @param {string} educationSlug
   * @returns Promise
   */
  update (slug, educationSlug, payload) {
    return axios.put(`/v1/profiles/${slug}/educations/${educationSlug}`, payload)
  },
  /**
   * Delete education list
   *
   * @param slug: string
   * @param {string} educationSlug
   * @returns Promise
   */
  delete (slug, educationSlug) {
    return axios.delete(`/v1/profiles/${slug}/educations/${educationSlug}`)
  },
  /**
   * Sort education list
   *
   * @param slug: string
   * @param {string} educationSlug
   * @param index: number
   * @returns Promise
   */
  sort (slug, educationSlug, index) {
    return axios.patch(`/v1/profiles/${slug}/educations/${educationSlug}/move`, { sort_index: index })
  }
})
